// Explicit public destinations only. Unknown/dynamic/account/issued-link routes fail
// closed. Query and fragment contents are never analytics input, even on public URLs.
const publicPaths = new Set(['/', '/shop', '/books', '/blog', '/podcast', '/about', '/contact', '/faq', '/privacy', '/terms', '/refund-policy', '/first-chapter']);

export function analyticsPage(url: string): string | null {
  try {
    const parsed = new URL(url);
    return !parsed.search && !parsed.hash && publicPaths.has(parsed.pathname) ? parsed.pathname : null;
  } catch { return null; }
}

export type HomepageAnalyticsEvent = 'home_page_view' | 'home_cta_click' | 'home_newsletter_submit' | 'home_product_click' | 'home_blog_click' | 'home_section_empty';
export type AnalyticsMetadata = Record<string, string | number | boolean | null | undefined>;
const enums: Record<string, ReadonlySet<string>> = {
  location: new Set(['promise_block', 'collection_banner', 'quiz_teaser', 'journal_header', 'hero', 'trust_strip', 'featured_primary', 'featured_side', 'moment_card', 'book_path', 'knot_card', 'journal_card']),
  status: new Set(['invalid', 'saved', 'error']),
  action: new Set(['view_book']),
  section: new Set(['featured_books', 'book_path', 'collection', 'journal']),
};

export function cleanAnalyticsMetadata(metadata: AnalyticsMetadata = {}) {
  const output: Record<string, string | number> = {};
  for (const [key, value] of Object.entries(metadata)) {
    if (typeof value === 'string' && enums[key]?.has(value)) output[key] = value;
    if (['position', 'empty_section_count'].includes(key) && typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= 100) output[key] = value;
    if (key === 'href' && typeof value === 'string' && value.startsWith('/') && !value.startsWith('//')) {
      const page = analyticsPage(`https://analytics.invalid${value}`);
      if (page) output.destination = page;
      // Preserve useful product/blog category counts without sending content IDs,
      // arbitrary slugs, owner-entered labels, link queries or fragments.
      else if (/^\/(titles|blog)\/[a-z0-9-]+$/.test(value)) output.destination = value.startsWith('/titles/') ? '/titles/:slug' : '/blog/:slug';
    }
  }
  return output;
}
